module.exports = __webpack_public_path__ + "img/icon-error.d2aee1a5.svg";